/**
 * Derives the WebSocket scheme from the API endpoint: `http` -> `ws`, `https` -> `wss`.
 */
export const toWsUrl = (endpoint?: string) => endpoint?.replace(/^http/, 'ws');
